/**
 * 模板选择器组件样式
 */

import { createStyles } from 'antd-style';
import  colorToken  from '../../utils/colorToken';

export const useTemplateSelectorStyles = createStyles(({ token, css }) => ({
  templateModal: css`
    .ant-modal-body {
      max-height: 60vh;
      overflow: auto;
    }
  `,
  templateGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: ${token.marginMD}px;
    margin-top: ${token.marginMD}px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  `,
  templateCard: css`
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid var(--color-border, ${colorToken.colorBorder});
    border-radius: ${token.borderRadius}px;
    overflow: hidden;
    
    &:hover {
      box-shadow: ${token.boxShadowTertiary};
      transform: translateY(-2px);
      border-color: var(--color-primary, ${colorToken.colorPrimary});
    }
  `,
  templateCardSelected: css`
    border-color: var(--color-primary, ${colorToken.colorPrimary}) !important;
    box-shadow: 0 0 0 2px var(--color-primary-bg, ${colorToken.colorPrimaryBg}) !important;
  `,
  templateHeader: css`
    display: flex;
    align-items: center;
    margin-bottom: ${token.marginXS}px;
    padding: ${token.padding}px;
    border-bottom: 1px solid var(--color-border, ${colorToken.colorBorder});
  `,
  templateIcon: css`
    margin-right: ${token.marginXS}px;
    color: var(--color-primary, ${colorToken.colorPrimary});
    font-size: ${token.fontSizeLG}px;
  `,
  templateTitle: css`
    font-size: ${token.fontSizeLG}px;
    font-weight: ${token.fontWeightStrong};
    margin-bottom: ${token.marginXS}px;
    color: var(--color-text-base, ${colorToken.colorTextBase});
  `,
  templateDescription: css`
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
    font-size: ${token.fontSizeSM}px;
    margin-bottom: ${token.marginSM}px;
    line-height: 1.4;
  `,
  templatePreview: css`
    background-color: var(--color-bg-container, ${colorToken.colorBgContainer});
    border: 1px solid var(--color-border, ${colorToken.colorBorder});
    border-radius: ${token.borderRadius}px;
    padding: ${token.paddingXS}px;
    font-size: ${token.fontSizeSM}px;
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
    max-height: 80px;
    overflow: hidden;
    position: relative;
    line-height: 1.4;
    
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 20px;
      background: linear-gradient(transparent, var(--color-bg-container, ${colorToken.colorBgContainer}));
    }
  `,
  searchBar: css`
    margin-bottom: ${token.marginMD}px;
  `,
  emptyState: css`
    text-align: center;
    padding: ${token.paddingLG * 2}px;
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
  `,
  templateMeta: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${token.paddingXS}px ${token.padding}px;
    background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
    border-top: 1px solid var(--color-border, ${colorToken.colorBorder});
  `,
  templateType: css`
    font-size: ${token.fontSizeSM}px;
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
  `,
  templateUsage: css`
    font-size: ${token.fontSizeSM}px;
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
  `,
  templateContent: css`
    padding: ${token.padding}px;
  `,
  categoryTabs: css`
    margin-bottom: ${token.marginMD}px;
  `,
  loadingContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  `,
}));
